module.exports = __webpack_public_path__ + "static/media/bank16.b82538c3.png";